import React, { useState, useEffect } from "react";

import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import {
  getUploadedReportsByME,
  seniorMarketingExecutiveList,
  seniorMarketingExecutivePincodeAdd,
  seniorMarketingExecutivePincodeList,
  // seniorMarketingExecutivePincodeAdd,
  // seniorMarketingExecutivePincodeList,
} from "../../Services/Operations/ProductAPI";

const SeniorMarketingExecutive = () => {
  const token = useSelector((state) => state.user.token);

  const [executives, setExecutives] = useState([]);
  const [currentExecutive, setCurrentExecutive] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Assign pincode modal states
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [zoneName, setZoneName] = useState("");
  const [pincodes, setPincodes] = useState([""]);
  const [assignLoading, setAssignLoading] = useState(false);

  // View linked pincodes modal states
  const [showLinkedModal, setShowLinkedModal] = useState(false);
  const [linkedPincodeData, setLinkedPincodeData] = useState([]);
  const [loadingPincodes, setLoadingPincodes] = useState(false);

  const [showReportsModal, setShowReportsModal] = useState(false);
  const [uploadedReports, setUploadedReports] = useState([]);
  const [reportsLoading, setReportsLoading] = useState(false);

  const [reportSearch, setReportSearch] = useState("");

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentExecutives = executives.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    const fetchExecutiveList = async () => {
      try {
        const response = await seniorMarketingExecutiveList(token);
        console.log("Senior Marketing Executive:", response);
        setExecutives(response.data);
      } catch (error) {
        console.error("Error fetching executive list:", error);
      }
    };

    if (token) {
      fetchExecutiveList();
    }
  }, [token]);

  const toggleStatus = async (id) => {
    // Add your status toggle API here
  };

  // Open assign pincode modal
  const openAssignModal = (executive) => {
    setSelectedEmployee(executive);
    setZoneName("");
    setPincodes([""]);
    setShowAssignModal(true);
  };

  // Handle pincode input change
  const handlePincodeChange = (index, value) => {
    if (!/^\d{0,6}$/.test(value)) return;

    const updatedPincodes = [...pincodes];
    updatedPincodes[index] = value;
    setPincodes(updatedPincodes);
  };

  // Add another pincode input
  const addPincodeField = () => {
    setPincodes((prev) => [...prev, ""]);
  };

  // Remove a pincode input
  const removePincodeField = (index) => {
    if (pincodes.length === 1) return;

    setPincodes((prev) => prev.filter((_, i) => i !== index));
  };

  // Submit pincode assignment
  const handleAssignPincodes = async () => {
    const validPincodes = pincodes
      .map((pin) => pin.trim())
      .filter((pin) => pin !== "");

    if (!zoneName.trim()) {
      toast.error("Please enter zone name");
      return;
    }

    if (validPincodes.length === 0) {
      toast.error("Please enter at least one pincode");
      return;
    }

    if (validPincodes.some((pin) => !/^\d{6}$/.test(pin))) {
      toast.error("Every pincode must contain exactly 6 digits");
      return;
    }

    const payload = {
      employeeId: Number(selectedEmployee.employeeId),
      zoneName: zoneName.trim(),
      pincodes: validPincodes,
    };

    try {
      setAssignLoading(true);
      console.log(payload);

      // Replace this with your actual API function/signature.
      const response = await seniorMarketingExecutivePincodeAdd(payload, token);

      console.log("Pincode assignment response:", response);

      toast.success(response?.message || "Pincodes assigned successfully");

      setShowAssignModal(false);
      setSelectedEmployee(null);
      setZoneName("");
      setPincodes([""]);
    } catch (error) {
      console.error("Error assigning pincodes:", error);
      toast.error(
        error?.response?.data?.message || "Failed to assign pincodes",
      );
    } finally {
      setAssignLoading(false);
    }
  };

  // Open linked pincodes modal and call API
  const handleViewLinkedPincodes = async (executive) => {
    setSelectedEmployee(executive);
    setShowLinkedModal(true);
    setLinkedPincodeData([]);

    try {
      setLoadingPincodes(true);

      // Replace this with your actual API function/signature.
      const response = await seniorMarketingExecutivePincodeList(
        executive?.employeeId,
        token,
      );

      console.log("Linked Pincodes:", response);

      setLinkedPincodeData(Array.isArray(response?.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching linked pincodes:", error);
      toast.error(
        error?.response?.data?.message || "Failed to fetch linked pincodes",
      );
    } finally {
      setLoadingPincodes(false);
    }
  };

  const handleOpenReports = async () => {
    setShowReportsModal(true);
    setReportsLoading(true);
    setUploadedReports([]);

    try {
      // Dummy API method — replace with your actual API
      const response = await getUploadedReportsByME(token);

      console.log("Uploaded Reports:", response);
      setUploadedReports(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching reports:", error);
      toast.error("Failed to fetch uploaded reports");
    } finally {
      setReportsLoading(false);
    }
  };

  const totalLinkedPincodes = linkedPincodeData.reduce(
    (total, zone) => total + (zone?.pincodes?.length || 0),
    0,
  );

  const formatDate = (dateArray) => {
    if (!dateArray || dateArray.length < 3) return "-";

    const [year, month, day] = dateArray;
    return `${String(day).padStart(2, "0")}/${String(month).padStart(2, "0")}/${year}`;
  };

  const formatTime = (timeArray) => {
    if (!timeArray || timeArray.length < 2) return "-";

    const [hours, minutes] = timeArray;
    const date = new Date();
    date.setHours(hours, minutes);

    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const filteredReports = uploadedReports.filter((report) =>
    report.submittedByName?.toLowerCase().includes(reportSearch.toLowerCase()),
  );

  return (
    <div id="main_content">
      <Header />

      <div className="page">
        <Section />

        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center">
              <div className="header-action">
                <h1 className="page-title">Senior Marketing Executive</h1>

                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>

                  <li className="breadcrumb-item active" aria-current="page">
                    Senior Marketing Executive
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <button className="btn btn-primary" onClick={handleOpenReports}>
                <i className="fa fa-file-alt me-2" />
                Uploaded Reports
              </button>
              <div
                className="tab-pane active"
                id="SeniorMarketingExecutive-all"
              >
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-hover js-basic-example dataTable table-striped table_custom border-style spacing5">
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>Id</th>
                            <th style={{ textAlign: "center" }}>Name</th>
                            <th style={{ textAlign: "center" }}>Number</th>
                            <th style={{ textAlign: "center" }}>Emp Type</th>
                            <th style={{ textAlign: "center" }}>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {currentExecutives?.map((executive, ind) => (
                            <tr key={executive?.employeeId}>
                              <td>{indexOfFirst + ind + 1}</td>
                              <td>{executive?.name}</td>
                              <td>{executive?.number}</td>
                              <td>{executive?.employeeType}</td>

                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: "8px",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    onClick={() => openAssignModal(executive)}
                                  >
                                    + Assign Pincodes
                                  </button>

                                  <button
                                    type="button"
                                    className="btn btn-info btn-sm"
                                    onClick={() =>
                                      handleViewLinkedPincodes(executive)
                                    }
                                  >
                                    View Pincodes
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}

                          {currentExecutives.length === 0 && (
                            <tr>
                              <td colSpan="5" className="text-center">
                                No Senior Marketing Executives Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                      <div
                        className="pagination mt-3"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage((prev) => prev - 1)}
                          className="btn btn-primary btn-sm me-2"
                        >
                          Prev
                        </button>

                        <span>
                          Page {currentPage} of{" "}
                          {Math.max(
                            1,
                            Math.ceil(executives.length / itemsPerPage),
                          )}
                        </span>

                        <button
                          disabled={
                            currentPage >=
                            Math.ceil(executives.length / itemsPerPage)
                          }
                          onClick={() => setCurrentPage((prev) => prev + 1)}
                          className="btn btn-primary btn-sm ms-2"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Assign Pincodes Modal */}
              {showAssignModal && (
                <div
                  onClick={() => setShowAssignModal(false)}
                  style={{
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(0,0,0,0.55)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "15px",
                  }}
                >
                  <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      width: "100%",
                      maxWidth: "520px",
                      maxHeight: "85vh",
                      overflowY: "auto",
                      backgroundColor: "#fff",
                      borderRadius: "12px",
                      padding: "25px",
                      boxShadow: "0 10px 35px rgba(0,0,0,0.2)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "20px",
                      }}
                    >
                      <h4 style={{ margin: 0 }}>Assign Pincodes</h4>

                      <button
                        type="button"
                        onClick={() => setShowAssignModal(false)}
                        style={{
                          border: "none",
                          background: "#eee",
                          borderRadius: "50%",
                          width: "30px",
                          height: "30px",
                          cursor: "pointer",
                        }}
                      >
                        X
                      </button>
                    </div>

                    <div style={{ marginBottom: "18px" }}>
                      <label style={{ fontWeight: "600" }}>Employee</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedEmployee?.name || ""}
                        disabled
                      />
                    </div>

                    <div style={{ marginBottom: "18px" }}>
                      <label style={{ fontWeight: "600" }}>Zone Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter zone name"
                        value={zoneName}
                        onChange={(e) => setZoneName(e.target.value)}
                      />
                    </div>

                    <div style={{ marginBottom: "10px" }}>
                      <label style={{ fontWeight: "600" }}>Pincodes</label>
                    </div>

                    {pincodes.map((pin, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginBottom: "12px",
                        }}
                      >
                        <input
                          type="text"
                          inputMode="numeric"
                          maxLength={6}
                          className="form-control"
                          placeholder={`Enter pincode ${index + 1}`}
                          value={pin}
                          onChange={(e) =>
                            handlePincodeChange(index, e.target.value)
                          }
                        />

                        {pincodes.length > 1 && (
                          <button
                            type="button"
                            onClick={() => removePincodeField(index)}
                            style={{
                              border: "none",
                              background: "#dc3545",
                              color: "#fff",
                              width: "34px",
                              height: "34px",
                              borderRadius: "6px",
                              cursor: "pointer",
                              flexShrink: 0,
                            }}
                          >
                            -
                          </button>
                        )}
                      </div>
                    ))}

                    <button
                      type="button"
                      onClick={addPincodeField}
                      className="btn btn-outline-primary btn-sm"
                      style={{ marginBottom: "20px" }}
                    >
                      + Add Another Pincode
                    </button>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                      }}
                    >
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowAssignModal(false)}
                      >
                        Cancel
                      </button>

                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleAssignPincodes}
                        disabled={assignLoading}
                      >
                        {assignLoading ? "Adding..." : "Add Pincodes"}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* View Linked Pincodes Modal */}
              {showLinkedModal && (
                <div
                  onClick={() => setShowLinkedModal(false)}
                  style={{
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(0,0,0,0.55)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "15px",
                  }}
                >
                  <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      width: "100%",
                      maxWidth: "650px",
                      maxHeight: "85vh",
                      overflowY: "auto",
                      backgroundColor: "#fff",
                      borderRadius: "12px",
                      padding: "25px",
                      boxShadow: "0 10px 35px rgba(0,0,0,0.2)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "20px",
                      }}
                    >
                      <div>
                        <h4 style={{ margin: 0 }}>Linked Pincodes</h4>
                        <small style={{ color: "#777" }}>
                          {selectedEmployee?.name}
                        </small>
                      </div>

                      <button
                        type="button"
                        onClick={() => setShowLinkedModal(false)}
                        style={{
                          border: "none",
                          background: "#eee",
                          borderRadius: "50%",
                          width: "30px",
                          height: "30px",
                          cursor: "pointer",
                        }}
                      >
                        X
                      </button>
                    </div>

                    {loadingPincodes ? (
                      <div className="text-center p-4">
                        Loading linked pincodes...
                      </div>
                    ) : (
                      <>
                        <div
                          style={{
                            background: "#f1f5ff",
                            padding: "15px",
                            borderRadius: "8px",
                            marginBottom: "20px",
                          }}
                        >
                          <div style={{ color: "#555" }}>
                            Total Linked Pincodes
                          </div>
                          <h3 style={{ margin: "5px 0 0", color: "#2457c5" }}>
                            {linkedPincodeData?.length||0}
                          </h3>
                        </div>

                        {linkedPincodeData.length === 0 ? (
                          <p className="text-center text-muted">
                            No pincodes linked with this employee.
                          </p>
                        ) : (
                          linkedPincodeData.map((zone, index) => (
                            <div
                              key={index}
                              style={{
                                border: "1px solid #e5e5e5",
                                borderRadius: "8px",
                                padding: "15px",
                                marginBottom: "12px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: "12px",
                                }}
                              >
                                <h5 style={{ margin: 0 }}>
                                  {zone?.zoneName || "Unnamed Zone"}
                                </h5>

                                <span
                                  style={{
                                    background: "#e8f2ff",
                                    color: "#2457c5",
                                    padding: "4px 10px",
                                    borderRadius: "20px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {zone?.pincode} 
                                </span>
                              </div>

                            
                            </div>
                          ))
                        )}
                      </>
                    )}

                    <div style={{ textAlign: "right", marginTop: "20px" }}>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowLinkedModal(false)}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Existing executive details modal retained */}
              {currentExecutive && (
                <div
                  style={{
                    position: "fixed",
                    top: "100px",
                    right: "200px",
                    zIndex: 999,
                    backgroundColor: "white",
                    padding: "20px",
                    border: "0.5px solid gray",
                    borderRadius: "10px",
                    minWidth: "450px",
                    maxWidth: "90%",
                    boxShadow: "0 5px 25px rgba(0,0,0,0.15)",
                  }}
                >
                  <div role="dialog">
                    <p
                      onClick={() => setCurrentExecutive(null)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "10px",
                        cursor: "pointer",
                        fontSize: "13px",
                        padding: "5px",
                        height: "30px",
                        width: "30px",
                        backgroundColor: "#cacaca",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      X
                    </p>

                    <div role="document">
                      <p style={{ fontSize: "20px", fontWeight: "800" }}>
                        Executive Name: {currentExecutive?.firstName}{" "}
                        {currentExecutive?.lastName}
                      </p>

                      <p style={{ fontWeight: "600", color: "#999" }}>
                        Email: {currentExecutive?.email}
                      </p>

                      <p style={{ fontWeight: "600", color: "#999" }}>
                        Phone Number:{" "}
                        {currentExecutive?.primaryNumber ||
                          currentExecutive?.phoneNumber ||
                          "-"}
                      </p>

                      <p style={{ fontSize: "14px" }}>
                        Address: {currentExecutive?.address || "-"}
                      </p>

                      <p style={{ fontSize: "14px" }}>
                        Status:{" "}
                        {currentExecutive?.status ? "Active" : "Inactive"}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {showReportsModal && (
                <div
                  onClick={() => setShowReportsModal(false)}
                  style={{
                    position: "fixed",
                    inset: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(20, 25, 35, 0.55)",
                    backdropFilter: "blur(5px)",
                    WebkitBackdropFilter: "blur(5px)",
                    zIndex: 99999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "20px",
                  }}
                >
                  <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      position: "relative",
                      width: "100%",
                      maxWidth: "850px",
                      maxHeight: "85vh",
                      background: "#fff",
                      borderRadius: "16px",
                      overflow: "hidden",
                      boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* Modal Header */}
                    <div
                      style={{
                        padding: "20px 24px",
                        borderBottom: "1px solid #eee",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexShrink: 0,
                      }}
                    >
                      <div>
                        <h4 style={{ margin: 0, fontWeight: "700" }}>
                          Uploaded Reports
                        </h4>
                        <small style={{ color: "#888" }}>
                          Reports submitted by employees
                        </small>
                      </div>

                      <button
                        type="button"
                        onClick={() => setShowReportsModal(false)}
                        style={{
                          width: "34px",
                          height: "34px",
                          border: "none",
                          borderRadius: "50%",
                          background: "#f1f1f1",
                          fontSize: "17px",
                          cursor: "pointer",
                        }}
                      >
                        ×
                      </button>
                    </div>
                    <div style={{ padding: "10px" }}>
                      <input
                        type="text"
                        placeholder="Search by employee name..."
                        value={reportSearch}
                        onChange={(e) => setReportSearch(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "11px 14px",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          outline: "none",
                          marginBottom: "18px",
                          fontSize: "14px",
                        }}
                      />
                    </div>
                    {/* Scrollable Modal Body */}
                    <div
                      style={{
                        padding: "20px 24px",
                        overflowY: "auto",
                        flex: 1,
                      }}
                    >
                      {/* KEEP YOUR EXISTING reportsLoading / uploadedReports JSX HERE */}

                      {reportsLoading ? (
                        <div className="text-center p-5">
                          <div className="spinner-border text-primary" />
                          <p className="mt-2 text-muted">Loading reports...</p>
                        </div>
                      ) : filteredReports.length === 0 ? (
                        <div className="text-center p-5">
                          <i
                            className="fa fa-folder-open"
                            style={{ fontSize: "40px", color: "#aaa" }}
                          />
                          <h5 className="mt-3">No Reports Found</h5>
                          <p className="text-muted">
                            No reports have been uploaded yet.
                          </p>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "16px",
                          }}
                        >
                          {uploadedReports.map((report, index) => (
                            <div
                              key={report.id || index}
                              style={{
                                border: "1px solid #e5eaf2",
                                borderRadius: "12px",
                                overflow: "hidden",
                                background: "#fff",
                                boxShadow: "0 3px 12px rgba(0,0,0,0.04)",
                              }}
                            >
                              {/* Report Header */}
                              <div
                                style={{
                                  padding: "15px 18px",
                                  background: "#f5f8ff",
                                  borderBottom: "1px solid #e5eaf2",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                <div>
                                  <div
                                    style={{ fontSize: "12px", color: "#888" }}
                                  >
                                    REPORT #{index + 1}
                                  </div>
                                  <h6
                                    style={{
                                      margin: "4px 0 0",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {report.submittedByName || "-"}
                                  </h6>
                                  <small style={{ color: "#777" }}>
                                    {report.submittedByRole || "-"}
                                  </small>
                                </div>

                                <span
                                  style={{
                                    background: "#e4f5e9",
                                    color: "#198754",
                                    padding: "6px 12px",
                                    borderRadius: "20px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                  }}
                                >
                                  {report.outcome || "No Outcome"}
                                </span>
                              </div>

                              <div style={{ padding: "18px" }}>
                                {/* Visit Details */}
                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns:
                                      "repeat(auto-fit, minmax(140px, 1fr))",
                                    gap: "15px",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <div>
                                    <small style={{ color: "#888" }}>
                                      Visit Date
                                    </small>
                                    <div
                                      style={{
                                        fontWeight: "600",
                                        marginTop: "4px",
                                      }}
                                    >
                                      <i className="fa fa-calendar text-primary me-2" />
                                      {formatDate(report.visitDate)}
                                    </div>
                                  </div>

                                  <div>
                                    <small style={{ color: "#888" }}>
                                      Visit Time
                                    </small>
                                    <div
                                      style={{
                                        fontWeight: "600",
                                        marginTop: "4px",
                                      }}
                                    >
                                      <i className="fa fa-clock-o text-primary me-2" />
                                      {formatTime(report.visitTime)}
                                    </div>
                                  </div>

                                  <div>
                                    <small style={{ color: "#888" }}>
                                      Doctor ID
                                    </small>
                                    <div
                                      style={{
                                        fontWeight: "600",
                                        marginTop: "4px",
                                      }}
                                    >
                                      #{report.doctorId ?? "-"}
                                    </div>
                                  </div>

                                  <div>
                                    <small style={{ color: "#888" }}>
                                      Chamber ID
                                    </small>
                                    <div
                                      style={{
                                        fontWeight: "600",
                                        marginTop: "4px",
                                      }}
                                    >
                                      #{report.chamberId ?? "-"}
                                    </div>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    height: "1px",
                                    background: "#eee",
                                    marginBottom: "18px",
                                  }}
                                />

                                {/* Discussion */}
                                <div style={{ marginBottom: "16px" }}>
                                  <div
                                    style={{
                                      fontSize: "13px",
                                      fontWeight: "700",
                                      color: "#555",
                                      marginBottom: "6px",
                                    }}
                                  >
                                    <i className="fa fa-comments text-primary me-2" />
                                    Discussion
                                  </div>
                                  <p
                                    style={{
                                      margin: 0,
                                      color: "#666",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {report.discussion || "-"}
                                  </p>
                                </div>

                                {/* Remarks */}
                                <div style={{ marginBottom: "16px" }}>
                                  <div
                                    style={{
                                      fontSize: "13px",
                                      fontWeight: "700",
                                      color: "#555",
                                      marginBottom: "6px",
                                    }}
                                  >
                                    <i className="fa fa-sticky-note text-primary me-2" />
                                    Remarks
                                  </div>
                                  <p
                                    style={{
                                      margin: 0,
                                      color: "#666",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {report.remarks || "-"}
                                  </p>
                                </div>

                                {/* Follow Up */}
                                <div
                                  style={{
                                    background: "#fff8e8",
                                    border: "1px solid #f5e5bd",
                                    borderRadius: "8px",
                                    padding: "12px 14px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    flexWrap: "wrap",
                                    gap: "8px",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: "13px",
                                      fontWeight: "600",
                                      color: "#856404",
                                    }}
                                  >
                                    <i className="fa fa-calendar-check-o me-2" />
                                    Next Follow-up
                                  </span>

                                  <span
                                    style={{
                                      fontWeight: "700",
                                      color: "#856404",
                                    }}
                                  >
                                    {formatDate(report.nextFollowUpDate)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default SeniorMarketingExecutive;
